module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("享玩甄选设置")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'name',
        prop: 'description'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "描述",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "150",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f3933bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/ShopList.vue
// module id = 719
// module chunks = 1